module.exports = __webpack_public_path__ + "img/ezgif.com-apng-maker-3.a750a975.png";